function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useMemo } from "react";
import { Avatar } from "./Avatar";
import { ArchiveButton } from "./ArchiveButton";
import { useKnockFeed } from "../KnockFeedProvider";
import { formatTimestamp, renderNodeOrFallback } from "../../utils";
import { useTranslations } from "../../hooks/useTranslations";
export var NotificationCell = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    item,
    onItemClick,
    avatar,
    children,
    archiveButton
  } = _ref;
  var {
    feedClient,
    colorMode
  } = useKnockFeed();
  var {
    dateFnsLocale
  } = useTranslations();
  var blocksByName = useMemo(() => {
    return item.blocks.reduce((acc, block) => {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [block.name]: block
      });
    }, {});
  }, [item]);
  var actionUrl = blocksByName.action_url && blocksByName.action_url.rendered;
  var onClick = React.useCallback(() => {
    // Mark as interacted + read once we click the item
    feedClient.markAsInteracted(item);
    if (onItemClick) return onItemClick(item); // Delay when we navigate, until we've actually issued our API call.

    setTimeout(() => {
      if (actionUrl && actionUrl !== "") {
        window.location.assign(actionUrl);
      }
    }, 200);
  }, [item]);
  var onKeyDown = React.useCallback(ev => {
    switch (ev.key) {
      case "Enter":
        {
          ev.stopPropagation();
          onClick();
          break;
        }

      default:
        break;
    }
  }, [onClick]);
  var actor = item.actors[0];
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "rnf-notification-cell rnf-notification-cell--".concat(colorMode),
    onClick: onClick,
    onKeyDown: onKeyDown,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-cell__inner"
  }, !item.read_at && /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-cell__unread-dot"
  }), renderNodeOrFallback(avatar, actor && "name" in actor && actor.name && /*#__PURE__*/React.createElement(Avatar, {
    name: actor.name,
    src: actor.avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-cell__content-outer"
  }, blocksByName.body && /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-cell__content",
    dangerouslySetInnerHTML: {
      __html: blocksByName.body.rendered
    }
  }), children && /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-cell__child-content"
  }, children), /*#__PURE__*/React.createElement("span", {
    className: "rnf-notification-cell__timestamp"
  }, formatTimestamp(item.inserted_at, {
    locale: dateFnsLocale()
  }))), renderNodeOrFallback(archiveButton, /*#__PURE__*/React.createElement(ArchiveButton, {
    item: item
  }))));
});
//# sourceMappingURL=NotificationCell.js.map